export default "__VITE_ASSET__DS8SbVYD__"